export default 'authentication';
